import { Component } from '@angular/core';
import { NaivagtionBarComponent } from './naivagtion-bar/naivagtion-bar.component'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'HomePage';
}
